function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import forEach from 'lodash/forEach';
import omit from 'lodash/omit';
import get from 'lodash/get';
class ValidatorRulesExtension {
    static addDefaults(rules, formValues) {
        const rulesCopy = JSON.parse(JSON.stringify(rules));
        forEach(omit(formValues, [
            'default'
        ]), (range, type)=>{
            forEach(range, (thresholds, thresholdsName)=>{
                const highThresholdValue = thresholds['highThreshold-toDisplay'];
                const lowThresholdValue = thresholds['lowThreshold-toDisplay'];
                if (lowThresholdValue === null && highThresholdValue && get(formValues, `default.${thresholdsName}.lowThreshold-toDisplay`) !== null) {
                    rulesCopy[`${type}.${thresholdsName}.highThreshold-toDisplay`] += `, greaterThen default.${thresholdsName}.lowThreshold-toDisplay`;
                }
                if (highThresholdValue === null && lowThresholdValue && get(formValues, `default.${thresholdsName}.lowThreshold-toDisplay`) !== null) {
                    rulesCopy[`${type}.${thresholdsName}.lowThreshold-toDisplay`] += `, lowerThen default.${thresholdsName}.highThreshold-toDisplay`;
                }
            });
        });
        return rulesCopy;
    }
}
_define_property(ValidatorRulesExtension, "highThresholdName", 'highThreshold-toDisplay');
_define_property(ValidatorRulesExtension, "lowThresholdName", 'lowThreshold-toDisplay');
export { ValidatorRulesExtension as default };
